import { Service, TeamMember, Testimonial } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const services: Service[] = [
  {
    id: 'bath-brush',
    title: 'Bath & Brush Service',
    description: 'Essential maintenance for large breeds. Deep cleansing bath followed by professional blow-dry and thorough brushing to maintain coat health.',
    price: '$45-100',
    duration: '1.5-2 hours',
    features: [
      'Deep cleansing bath',
      'Professional blow-dry',
      'Complete brush-out',
      'Nail trim',
      'Ear cleaning',
      'Coat conditioning treatment',
    ],
    imageUrl: IMAGES.GROOMER_WORK_2,
  },
  {
    id: 'deshedding',
    title: 'De-Shedding Treatment',
    description: 'Specialized treatment for heavy-coated breeds. Reduces shedding by up to 80% using professional-grade tools and techniques.',
    price: '$55-120',
    duration: '2-3 hours',
    features: [
      'Specialized de-shedding shampoo',
      'High-velocity blow-dry',
      'Professional undercoat removal',
      'Coat conditioning',
      'Nail trim and ear cleaning',
      'Follow-up maintenance tips',
    ],
    imageUrl: IMAGES.GROOMER_WORK_3,
  },
  {
    id: 'nail-care',
    title: 'Nail Care & Paw Maintenance',
    description: 'Focused care for large breed paws. Includes nail trimming, filing, and paw pad conditioning to ensure comfort and mobility.',
    price: '$25-40',
    duration: '30-45 min',
    features: [
      'Precision nail trimming',
      'Nail filing and smoothing',
      'Paw pad inspection',
      'Paw pad moisturizing',
      'Quick check and safety assessment',
    ],
    imageUrl: IMAGES.GROOMER_WORK_4,
  },
  {
    id: 'puppy-intro',
    title: 'Puppy Introduction Package',
    description: 'Gentle introduction to grooming for large breed puppies. Builds positive associations and establishes grooming routines early.',
    price: '$40-80',
    duration: '1-1.5 hours',
    features: [
      'Gentle handling and desensitization',
      'Basic bath and dry',
      'Nail trim introduction',
      'Ear cleaning',
      'Positive reinforcement training',
      'Owner education session',
    ],
    imageUrl: IMAGES.GROOMER_WORK_6,
  },
];

export const teamMembers: TeamMember[] = [
  {
    id: 'marcus-steel',
    name: 'Marcus Steel',
    role: 'Master Groomer & Founder',
    bio: 'With over 15 years specializing in large and giant breeds, Marcus founded our salon to provide professional grooming services that match the strength and dignity of powerful dogs. Certified in handling and grooming techniques for working breeds.',
    imageUrl: IMAGES.LARGE_BREEDS_1,
    specialties: [
      'Mastiff breeds',
      'Working dogs',
      'Behavioral handling',
      'Coat restoration',
    ],
  },
  {
    id: 'sarah-forge',
    name: 'Sarah Forge',
    role: 'Senior Groomer',
    bio: 'Sarah brings 12 years of experience working with guardian breeds and large working dogs. Her calm, confident approach ensures even the most powerful dogs feel secure during grooming sessions.',
    imageUrl: IMAGES.LARGE_BREEDS_2,
    specialties: [
      'Cane Corso',
      'Rottweiler',
      'De-shedding specialist',
      'Puppy training',
    ],
  },
  {
    id: 'david-iron',
    name: 'David Iron',
    role: 'Grooming Specialist',
    bio: 'David specializes in handling and grooming large, high-energy breeds. His background in canine behavior ensures safe, stress-free grooming experiences for dogs of all temperaments.',
    imageUrl: IMAGES.LARGE_BREEDS_3,
    specialties: [
      'Giant breeds',
      'Behavioral management',
      'Coat conditioning',
      'Nail care',
    ],
  },
  {
    id: 'elena-stone',
    name: 'Elena Stone',
    role: 'Grooming Technician',
    bio: 'Elena focuses on the technical aspects of grooming large breeds, from precision trimming to specialized coat treatments. Her attention to detail ensures every dog leaves looking their absolute best.',
    imageUrl: IMAGES.LARGE_BREEDS_4,
    specialties: [
      'Breed-specific styling',
      'Coat health',
      'Dental care',
      'Show preparation',
    ],
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 'test-1',
    clientName: 'Robert Chen',
    dogName: 'Titan',
    dogBreed: 'Cane Corso',
    rating: 5,
    comment: 'Finally found a grooming salon that understands large breeds. Marcus and his team handle Titan with confidence and respect. No more stress for either of us. The facility is clean, professional, and built for serious dogs.',
    imageUrl: IMAGES.LARGE_BREEDS_5,
  },
  {
    id: 'test-2',
    clientName: 'Jennifer Walsh',
    dogName: 'Atlas',
    dogBreed: 'English Mastiff',
    rating: 5,
    comment: 'Atlas is 180 pounds and most groomers refuse to work with him. This team treats him like the gentleman he is. Professional, capable, and they actually know how to handle giant breeds. Worth every penny.',
    imageUrl: IMAGES.LARGE_BREEDS_6,
  },
  {
    id: 'test-3',
    clientName: 'Michael Torres',
    dogName: 'Brutus',
    dogBreed: 'Rottweiler',
    rating: 5,
    comment: 'The de-shedding treatment is incredible. Brutus looks amazing and our house is finally fur-free. Sarah knows exactly what she\'s doing with working breeds. This is the only place I trust with my dog.',
    imageUrl: IMAGES.LARGE_BREEDS_7,
  },
  {
    id: 'test-4',
    clientName: 'Amanda Foster',
    dogName: 'Zeus',
    dogBreed: 'Doberman',
    rating: 5,
    comment: 'Professional, no-nonsense service that matches the quality you\'d expect for a premium breed. Zeus always comes home looking sharp and well-cared for. The team\'s expertise with large dogs is evident in everything they do.',
    imageUrl: IMAGES.LARGE_BREEDS_8,
  },
  {
    id: 'test-5',
    clientName: 'David Park',
    dogName: 'Maximus',
    dogBreed: 'Bullmastiff',
    rating: 5,
    comment: 'Started bringing Maximus here as a puppy. The team\'s approach to building positive grooming habits has been invaluable. Now at 140 pounds, he actually enjoys his grooming sessions. Highly recommend for large breed owners.',
    imageUrl: IMAGES.LARGE_BREEDS_9,
  },
  {
    id: 'test-6',
    clientName: 'Lisa Martinez',
    dogName: 'Duke',
    dogBreed: 'Great Dane',
    rating: 5,
    comment: 'Duke is a gentle giant but his size intimidates most groomers. Not here. The team handles him with calm confidence and the results are always excellent. This is what professional grooming for large breeds should be.',
    imageUrl: IMAGES.LARGE_BREEDS_10,
  },
];